<template>
  <Dropdown
    :label="$t('versions')"
    :ui="{ label: 'text-brand', items: 'lg:left-1/2 lg:-translate-x-1/2' }"
  >
    <DropdownSection>
      <DropdownItem
        :button="{ prependIcon: 'pencil' }"
        @click="renamePersonalisation"
      >
        {{ $t("rename_version") }}
      </DropdownItem>
      <DropdownItem
        :button="{ prependIcon: 'plus' }"
        @click="$modal.open(NewPersonalisationsModal, { sharedCollectionHashid })"
      >
        {{ $t("new_version") }}
      </DropdownItem>
      <DropdownItem
        :button="{ prependIcon: 'question', prependIconPrefix: 'fas' }"
        @click="$modal.open(LearnMoreModal)"
      >
        {{ $t("learn_more") }}
      </DropdownItem>
    </DropdownSection>
    <DropdownSection>
      <DropdownItem
        v-for="personalisation in availablePersonalisations"
        :key="personalisation.landing_page_url"
        :button="personalisation.hashid === getVersionHashidFromUrl() ? { appendIcon: 'check' } : undefined"
        @click="changePersonalisation(personalisation)"
      >
        {{ personalisation.name }}
      </DropdownItem>
    </DropdownSection>
  </Dropdown>
</template>

<script setup lang="ts">
import { parseURL } from 'ufo'
import type { LandingPage } from '~/types/landing-page'
import type { CollectionPersonalisation } from '~/types/collection'
import type { LaravelResponse } from '~/types/api'

const props = defineProps<{
  sharedCollectionHashid: string
  personalisations: LandingPage['personalisations']
}>()

const availablePersonalisations = computed(() => props.personalisations.filter(personalisation => !personalisation.collaborator_version))
const NewPersonalisationsModal = resolveComponent('LazyNewPersonalisationsModal')
const RenamePersonalisationsModal = resolveComponent('LazyRenamePersonalisationsModal')
const LearnMoreModal = resolveComponent('LazyPersonalisationsLearnMoreModal')

const renamePersonalisation = async () => {
  const { getPersonalisation, updatePersonalisation } = useLandingPage()
  const { openModal } = useModal()

  const updatedPersonalisation = await openModal<LaravelResponse<CollectionPersonalisation>>(RenamePersonalisationsModal, {
    sharedCollectionHashid: props.sharedCollectionHashid,
    personalisation: getPersonalisation(getVersionHashidFromUrl())
  })

  if (updatedPersonalisation?.data?.id) {
    updatePersonalisation(updatedPersonalisation.data)
  }
}

const changePersonalisation = async (personalisation: LandingPage['personalisations'][number]) => {
  const pathname = parseURL(personalisation.landing_page_url).pathname
  await navigateTo(pathname)
}
</script>
